import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { cif } from './validator';

@Directive({
    selector: '[cif][formControlName],[cif][formControl],[cif][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CIFValidatorDirective),
            multi: true,
        },
    ],
})
export class CIFValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = cif();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
